import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";

export const searchConfig: QuestionBase[] = [
  {
    key: "name",
    label: "Nome",
    required: false,
    controlType: "textbox",
    placeholder: "Inserire Nome",
    size: "sm-6",
    type: "text",
  },
  {
    key: "type",
    label: "Tipo Società",
    placeholder: "Seleziona tipo società",
    options: [],
    size: "sm-6",
    required: false,
    controlType: "dropdown",
    type: "",
  },
  // {
  //   key: "owner",
  //   label: "Proprietario",
  //   placeholder: "Seleziona Proprietario",
  //   options: [],
  //   size: "sm-4",
  //   required: false,
  //   controlType: "dropdown",
  //   type: "",
  // },
  {
    key: "scope",
    label: "Tipo sede",
    placeholder: "Seleziona tipo sede",
    options: [],
    size: "sm-4",
    required: false,
    controlType: "dropdown",
    type: "",
  },
  {
    key: "taxCode",
    label: "Codice fiscale",
    required: false,
    controlType: "textbox",
    placeholder: "Inserisci codice fiscale",
    size: "sm-4",
    type: "text",
  },
  {
    key: "vatNumber",
    label: "Partita Iva",
    required: false,
    controlType: "textbox",
    placeholder: "Inserisci Partita Iva",
    size: "sm-4",
    type: "text",
  }

];
